// Bilingual content for Tenorio Master Roofing
export const translations = {
  en: {
    phone: { display: "(626) 343-1971", tel: "+16263431971" },
    nav: {
      services: "Services",
      about: "About",
      gallery: "Work",
      contact: "Contact",
      quote: "Get a Quote",
    },
    hero: {
      eyebrow: "Tenorio Master Inc. Roofing",
      title: "Expert Roofing & Skylight Services",
      subtitle:
        "Over 25 years of experience. A family business built on integrity, delivering quality at affordable rates.",
      callCta: "Call Now: (626) 343-1971",
      quoteCta: "Request a Free Quote",
      badge1: "25+ Years Experience",
      badge2: "Latinx-Owned",
      badge3: "Family Business",
      badge4: "Licensed · #1162340",
      strip: "Free Estimates · Same-Day Callback",
    },
    trust: {
      tag: "About Us",
      title: "A family name built on roofs that last.",
      lead:
        "Tenorio Master Roofing is a proud Latinx-owned, family-run business serving homeowners with honest work, careful craftsmanship, and fair pricing.",
      p1:
        "For more than 25 years we've climbed ladders across Southern California — fixing leaks, replacing aging shingles, installing skylights, and giving homes the protection they deserve.",
      p2:
        "Our promise is simple: do the job right, treat your home like our own, and stand behind every nail.",
      stat1Label: "Years on the roof",
      stat1Value: "25+",
      stat2Label: "Family-owned",
      stat2Value: "100%",
      stat3Label: "Core value",
      stat3Value: "Integrity",
      licenseLabel: "Contractor License",
      licenseVerifyCta: "Verify on CSLB",
      yearsBadge: "Years of trusted work",
    },
    services: {
      tag: "Our Services",
      title: "Roof care, from first inspection to final shingle.",
      subtitle:
        "Residential roofing done with the same care a family puts into their own home.",
      cta: "Request a quote",
      items: [
        {
          name: "Roof Inspection",
          desc: "Thorough top-to-bottom inspection so you know exactly what your roof needs.",
        },
        {
          name: "New Roof Installation",
          desc: "Full-system installs built to last decades, sealed and inspected at every step.",
        },
        {
          name: "Roof Repair",
          desc: "Fast, lasting repairs for leaks, storm damage, and worn-out flashing.",
        },
        {
          name: "Roof Replacement",
          desc: "Tear-off and re-build with quality materials, clean job sites, and zero shortcuts.",
        },
        {
          name: "Reroofing",
          desc: "Cost-effective overlays for eligible roofs, restoring strength and curb appeal.",
        },
        {
          name: "Skylight Installation",
          desc: "Bring natural light into your home with watertight, professionally installed skylights.",
        },
        {
          name: "Skylight Repair",
          desc: "Fix foggy glass, seal leaks, and restore your skylight to like-new performance.",
        },
      ],
    },
    gallery: {
      tag: "Recent Work",
      title: "Real roofs. Real homes. Real craftsmanship.",
      subtitle: "A small look at jobs we've completed across the neighborhood.",
      qualityTag: "Quality",
      qualityTitle: "Built right. Built to last.",
    },
    contact: {
      tag: "Get In Touch",
      title: "Request a free, no-pressure quote.",
      subtitle:
        "Tell us about your roof and we'll get back to you the same day. Or call us — we love picking up the phone.",
      hoursTitle: "Hours of Operation",
      monSat: "Mon – Sat",
      monSatHours: "6:30 AM – 5:00 PM",
      sun: "Sunday",
      sunHours: "8:00 AM – 2:00 PM",
      phoneLabel: "Phone",
      emailLabel: "Email",
      formTitle: "Send us a message",
      nameLabel: "Full Name",
      namePh: "Maria Gonzalez",
      phoneLabelForm: "Phone Number",
      phonePh: "(626) 555-0100",
      serviceLabel: "Service Needed (optional)",
      messageLabel: "How can we help?",
      messagePh: "Tell us about your roof, address, or anything else we should know...",
      submit: "Send Request",
      submitting: "Sending...",
      success: "Thanks! We'll call you back shortly.",
      error: "Something went wrong. Please call us at (626) 343-1971.",
      validation: "Please fill in your name and phone number.",
      tooMany: "Too many requests from this device. Please call us at (626) 343-1971.",
    },
    payments: {
      tag: "Easy Payments",
      title: "Accepted Payment Methods",
      subtitle:
        "Pay the way that's most convenient for you. We make checkout simple.",
      methods: ["Cash", "Check", "Credit/Debit Card"],
    },
    footer: {
      tagline: "Roofing the way it should be — honest, careful, built to last.",
      rights: "All rights reserved.",
      dba: "Tenorio Master Inc. Roofing · Family-owned & operated",
      license: "License #1162340",
      licenseHeader: "License Number: #1162340",
      credentials: "Licensed · Bonded · Insured · Workers' Comp.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      backHome: "Back to home",
      licenseVerify: "Verify license #1162340 on the CSLB website",
      licenseCopied: "License #1162340 copied",
      licenseCopiedDesc: "Paste it into the CSLB search box to verify.",
      yelp: "See our photos & reviews on Yelp",
      yelpDisclaimer:
        "Yelp is a registered trademark of Yelp Inc. Tenorio Master Roofing is not affiliated with, endorsed by, or sponsored by Yelp in any way.",
    },
    mobile: {
      callNow: "Call Now",
    },
    consent: {
      agreePrefix: "By submitting, you agree to our ",
      and: " and ",
      agreeSuffix: ".",
      sms: "I agree to receive text messages from Tenorio Master Inc. Roofing about my quote. Msg & data rates may apply. Reply STOP to opt out.",
      optional: "Optional",
    },
    area: {
      basedIn: "Based in West Covina, CA",
      serving: "Proudly serving",
      surrounding: "and the surrounding San Gabriel Valley",
    },
    reviews: {
      tag: "Reviews",
      title: "Don't take our word for it.",
      copy: "Read what neighbors across the San Gabriel Valley say about working with us.",
      cta: "Read our reviews on Yelp",
    },
    legal: {
      effective: "Effective date: June 1, 2026",
      entity:
        "This site is operated by TENORIO MASTER IN CORPORATION ROOFING, doing business as Tenorio Master Roofing (CSLB License #1162340), West Covina, California.",
      disclaimer:
        "This page is provided for general information and is not legal advice.",
      privacy: {
        title: "Privacy Policy",
        intro:
          "We respect your privacy. This policy explains what information we collect through this website, how we use it, and the choices you have.",
        sections: [
          {
            h: "What we collect",
            p: "When you use the quote request form we collect your name, phone number, the service you need, your message, and — if you choose to tick the box — your consent to receive text messages about your quote. We also keep the language you used (English or Spanish) so we can call you back in it.",
          },
          {
            h: "How we use it",
            p: "We use this information only to respond to your request, schedule inspections, and provide estimates. We do not sell your information, and we do not share it with third parties for their marketing.",
          },
          {
            h: "Text messages",
            p: "If you tick the optional SMS box, you agree that Tenorio Master Inc. Roofing may text you about your quote. Message and data rates may apply. You can reply STOP at any time to opt out. Consent is not a condition of receiving an estimate.",
          },
          {
            h: "Cookies and analytics",
            p: "This website does not use advertising cookies or third-party analytics trackers. Your language preference is stored in your browser so the site remembers it on your next visit.",
          },
          {
            h: "How long we keep it",
            p: "We keep quote requests for as long as needed to serve you and to meet our record-keeping obligations as a licensed California contractor.",
          },
          {
            h: "Your choices",
            p: "You may ask us to view, correct, or delete the information you submitted at any time by emailing tenoriomasterincroofing@gmail.com. We will respond within a reasonable time.",
          },
          {
            h: "Changes",
            p: "If we update this policy, we will post the new version here with a new effective date.",
          },
        ],
      },
      terms: {
        title: "Terms of Service",
        intro:
          "By using this website or requesting a quote, you agree to the following terms.",
        sections: [
          {
            h: "Estimates",
            p: "Any price, timeline, or scope shared by phone, text, email, or through this site is an estimate only. Nothing is binding on either party until a written contract is signed by you and by Tenorio Master Inc. Roofing.",
          },
          {
            h: "Website content",
            p: "Content on this site — including photos, descriptions of services, and hours — is provided for general information and may change without notice. We make reasonable efforts to keep it accurate but do not guarantee it.",
          },
          {
            h: "Licensing",
            p: "Tenorio Master Inc. Roofing is licensed by the California Contractors State License Board, License #1162340. You can verify our license at cslb.ca.gov.",
          },
          {
            h: "Communications",
            p: "By submitting the quote form you agree that we may contact you by phone or email about your request. Text messages are sent only if you give separate, optional consent.",
          },
          {
            h: "Governing law",
            p: "These terms are governed by the laws of the State of California, without regard to conflict-of-law rules.",
          },
          {
            h: "Contact",
            p: "Questions about these terms? Email tenoriomasterincroofing@gmail.com or call (626) 343-1971.",
          },
        ],
      },
    },
    lang: {
      en: "EN",
      es: "ES",
    },
  },
  es: {
    phone: { display: "(626) 664-0571", tel: "+16266640571" },
    nav: {
      services: "Servicios",
      about: "Nosotros",
      gallery: "Trabajos",
      contact: "Contacto",
      quote: "Pedir Cotización",
    },
    hero: {
      eyebrow: "Tenorio Master Inc. Roofing",
      title: "Servicios Expertos de Techos y Tragaluces",
      subtitle:
        "Más de 25 años de experiencia. Un negocio familiar fundado en la integridad, ofreciendo calidad a precios accesibles.",
      callCta: "Llámanos: (626) 664-0571",
      quoteCta: "Cotización Gratis",
      badge1: "25+ Años de Experiencia",
      badge2: "Negocio Latino",
      badge3: "Empresa Familiar",
      badge4: "Con Licencia · #1162340",
      strip: "Cotizaciones Gratis · Te Llamamos el Mismo Día",
    },
    trust: {
      tag: "Sobre Nosotros",
      title: "Un apellido familiar construido sobre techos que duran.",
      lead:
        "Tenorio Master Roofing es un negocio familiar latino que sirve a los dueños de casa con trabajo honesto, mano de obra cuidadosa y precios justos.",
      p1:
        "Por más de 25 años hemos trabajado por todo el sur de California — reparando goteras, reemplazando tejas viejas, instalando tragaluces y dando a las casas la protección que merecen.",
      p2:
        "Nuestra promesa es simple: hacer el trabajo bien hecho, tratar tu casa como la nuestra y responder por cada clavo.",
      stat1Label: "Años en el techo",
      stat1Value: "25+",
      stat2Label: "Familiar",
      stat2Value: "100%",
      stat3Label: "Valor central",
      stat3Value: "Integridad",
      licenseLabel: "Licencia de Contratista",
      licenseVerifyCta: "Verificar en CSLB",
      yearsBadge: "Años de trabajo confiable",
    },
    services: {
      tag: "Nuestros Servicios",
      title: "Cuidado del techo, desde la inspección hasta la última teja.",
      subtitle:
        "Trabajos residenciales hechos con el mismo cuidado que una familia pone en su propia casa.",
      cta: "Pedir cotización",
      items: [
        {
          name: "Inspección de Techo",
          desc: "Inspección minuciosa para que sepas exactamente qué necesita tu techo.",
        },
        {
          name: "Instalación de Techo Nuevo",
          desc: "Instalaciones completas hechas para durar décadas, selladas e inspeccionadas en cada paso.",
        },
        {
          name: "Reparación de Techo",
          desc: "Reparaciones rápidas y duraderas para goteras, daños por tormenta y flashing gastado.",
        },
        {
          name: "Reemplazo de Techo",
          desc: "Removemos y reconstruimos con materiales de calidad y sitios de trabajo limpios.",
        },
        {
          name: "Recubrimiento (Reroofing)",
          desc: "Soluciones económicas para techos elegibles, restaurando fuerza y apariencia.",
        },
        {
          name: "Instalación de Tragaluz",
          desc: "Trae luz natural a tu casa con tragaluces instalados profesionalmente y a prueba de agua.",
        },
        {
          name: "Reparación de Tragaluz",
          desc: "Arreglamos vidrios empañados, sellamos fugas y devolvemos tu tragaluz a su mejor estado.",
        },
      ],
    },
    gallery: {
      tag: "Trabajos Recientes",
      title: "Techos reales. Hogares reales. Trabajo de verdad.",
      subtitle:
        "Una pequeña muestra de trabajos que hemos completado en el vecindario.",
      qualityTag: "Calidad",
      qualityTitle: "Bien hecho. Hecho para durar.",
    },
    contact: {
      tag: "Contáctanos",
      title: "Pide una cotización gratis, sin presión.",
      subtitle:
        "Cuéntanos de tu techo y te responderemos el mismo día. O llámanos — nos encanta contestar el teléfono.",
      hoursTitle: "Horario de Atención",
      monSat: "Lun – Sáb",
      monSatHours: "6:30 AM – 5:00 PM",
      sun: "Domingo",
      sunHours: "8:00 AM – 2:00 PM",
      phoneLabel: "Teléfono",
      emailLabel: "Correo",
      formTitle: "Envíanos un mensaje",
      nameLabel: "Nombre completo",
      namePh: "María González",
      phoneLabelForm: "Número de teléfono",
      phonePh: "(626) 555-0100",
      serviceLabel: "Servicio que necesitas (opcional)",
      messageLabel: "¿Cómo te podemos ayudar?",
      messagePh:
        "Cuéntanos sobre tu techo, tu dirección, o cualquier cosa que debamos saber...",
      submit: "Enviar Solicitud",
      submitting: "Enviando...",
      success: "¡Gracias! Te llamaremos pronto.",
      error: "Algo salió mal. Por favor llámanos al (626) 664-0571.",
      validation: "Por favor llena tu nombre y teléfono.",
      tooMany: "Demasiadas solicitudes desde este dispositivo. Por favor llámanos al (626) 664-0571.",
    },
    payments: {
      tag: "Pagos Fáciles",
      title: "Métodos de Pago Aceptados",
      subtitle:
        "Paga de la forma que te sea más conveniente. Lo hacemos fácil.",
      methods: ["Efectivo", "Cheque", "Tarjeta de Crédito/Débito"],
    },
    footer: {
      tagline:
        "Techos hechos como deben hacerse — honestos, cuidadosos y para durar.",
      rights: "Todos los derechos reservados.",
      dba: "Tenorio Master Inc. Roofing · Family-owned & operated",
      license: "Licencia #1162340",
      licenseHeader: "Número de Licencia: #1162340",
      credentials: "Con Licencia · Fianza · Asegurados · Seguro de Trabajadores",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      backHome: "Volver al inicio",
      licenseVerify: "Verifica la licencia #1162340 en el sitio del CSLB",
      licenseCopied: "Licencia #1162340 copiada",
      licenseCopiedDesc: "Pégala en el buscador del CSLB para verificarla.",
      yelp: "Mira nuestras fotos y reseñas en Yelp",
      yelpDisclaimer:
        "Yelp es una marca registrada de Yelp Inc. Tenorio Master Roofing no está afiliado, respaldado ni patrocinado por Yelp de ninguna manera.",
    },
    mobile: {
      callNow: "Llamar",
    },
    consent: {
      agreePrefix: "Al enviar, aceptas nuestra ",
      and: " y nuestros ",
      agreeSuffix: ".",
      sms: "Acepto recibir mensajes de texto de Tenorio Master Inc. Roofing sobre mi cotización. Pueden aplicarse tarifas de mensajes y datos. Responde STOP para cancelar.",
      optional: "Opcional",
    },
    area: {
      basedIn: "Con sede en West Covina, CA",
      serving: "Orgullosamente servimos a",
      surrounding: "y el resto del Valle de San Gabriel",
    },
    reviews: {
      tag: "Reseñas",
      title: "No te quedes solo con nuestra palabra.",
      copy: "Lee lo que dicen tus vecinos del Valle de San Gabriel sobre trabajar con nosotros.",
      cta: "Lee nuestras reseñas en Yelp",
    },
    legal: {
      effective: "Fecha de vigencia: 1 de junio de 2026",
      entity:
        "Este sitio es operado por TENORIO MASTER IN CORPORATION ROOFING, que opera bajo el nombre Tenorio Master Roofing (Licencia CSLB #1162340), West Covina, California.",
      disclaimer:
        "Esta página es solo informativa y no constituye asesoría legal.",
      privacy: {
        title: "Política de Privacidad",
        intro:
          "Respetamos tu privacidad. Esta política explica qué información recopilamos a través de este sitio, cómo la usamos y las opciones que tienes.",
        sections: [
          {
            h: "Qué recopilamos",
            p: "Cuando usas el formulario de cotización recopilamos tu nombre, número de teléfono, el servicio que necesitas, tu mensaje y — si marcas la casilla — tu consentimiento para recibir mensajes de texto sobre tu cotización. También guardamos el idioma que usaste (inglés o español) para llamarte en ese idioma.",
          },
          {
            h: "Cómo la usamos",
            p: "Usamos esta información únicamente para responder a tu solicitud, programar inspecciones y darte estimados. No vendemos tu información ni la compartimos con terceros para su publicidad.",
          },
          {
            h: "Mensajes de texto",
            p: "Si marcas la casilla opcional de SMS, aceptas que Tenorio Master Inc. Roofing te envíe mensajes de texto sobre tu cotización. Pueden aplicarse tarifas de mensajes y datos. Puedes responder STOP en cualquier momento para cancelar. El consentimiento no es condición para recibir un estimado.",
          },
          {
            h: "Cookies y analíticas",
            p: "Este sitio no usa cookies publicitarias ni rastreadores de analíticas de terceros. Tu preferencia de idioma se guarda en tu navegador para recordarla en tu próxima visita.",
          },
          {
            h: "Cuánto tiempo la guardamos",
            p: "Guardamos las solicitudes de cotización el tiempo necesario para atenderte y cumplir con nuestras obligaciones de registro como contratista con licencia en California.",
          },
          {
            h: "Tus opciones",
            p: "Puedes pedirnos ver, corregir o eliminar la información que enviaste en cualquier momento escribiendo a tenoriomasterincroofing@gmail.com. Responderemos en un plazo razonable.",
          },
          {
            h: "Cambios",
            p: "Si actualizamos esta política, publicaremos la nueva versión aquí con una nueva fecha de vigencia.",
          },
        ],
      },
      terms: {
        title: "Términos de Servicio",
        intro:
          "Al usar este sitio o pedir una cotización, aceptas los siguientes términos.",
        sections: [
          {
            h: "Estimados",
            p: "Cualquier precio, plazo o alcance compartido por teléfono, texto, correo o a través de este sitio es solo un estimado. Nada es vinculante para ninguna de las partes hasta que tú y Tenorio Master Inc. Roofing firmen un contrato por escrito.",
          },
          {
            h: "Contenido del sitio",
            p: "El contenido de este sitio — incluyendo fotos, descripciones de servicios y horarios — es informativo y puede cambiar sin previo aviso. Hacemos esfuerzos razonables para mantenerlo exacto, pero no lo garantizamos.",
          },
          {
            h: "Licencia",
            p: "Tenorio Master Inc. Roofing cuenta con licencia de la Junta Estatal de Licencias de Contratistas de California (CSLB), Licencia #1162340. Puedes verificarla en cslb.ca.gov.",
          },
          {
            h: "Comunicaciones",
            p: "Al enviar el formulario de cotización aceptas que te contactemos por teléfono o correo sobre tu solicitud. Los mensajes de texto se envían solo si das tu consentimiento opcional por separado.",
          },
          {
            h: "Ley aplicable",
            p: "Estos términos se rigen por las leyes del Estado de California, sin considerar sus normas sobre conflicto de leyes.",
          },
          {
            h: "Contacto",
            p: "¿Preguntas sobre estos términos? Escribe a tenoriomasterincroofing@gmail.com o llama al (626) 664-0571.",
          },
        ],
      },
    },
    lang: {
      en: "EN",
      es: "ES",
    },
  },
};

export const EMAIL = "tenoriomasterincroofing@gmail.com";

export const SERVICE_CITIES = [
  "West Covina",
  "Covina",
  "Baldwin Park",
  "La Puente",
  "Walnut",
  "Azusa",
  "Glendora",
  "Irwindale",
  "San Dimas",
  "Diamond Bar",
  "Hacienda Heights",
  "El Monte",
];

export const LICENSE_NUMBER = "1162340";
export const CSLB_URL =
  "https://www2.cslb.ca.gov/onlineservices/checklicenseII/checklicense.aspx";

export const YELP_URL =
  "https://www.yelp.com/biz_photos/tenorio-master-roofing-west-covina-3?dd_referrer=";

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_9a9b562d-e069-423e-aa59-16e2a60f5f68/artifacts/a2bre7aw_o.jpg",
  about: "https://customer-assets.emergentagent.com/job_9a9b562d-e069-423e-aa59-16e2a60f5f68/artifacts/7gd50xx5_o.jpg",
  gallery: [
    "https://customer-assets.emergentagent.com/job_9a9b562d-e069-423e-aa59-16e2a60f5f68/artifacts/64jw6z52_o.jpg",
    "https://customer-assets.emergentagent.com/job_9a9b562d-e069-423e-aa59-16e2a60f5f68/artifacts/7vujk749_o.jpg",
    "https://customer-assets.emergentagent.com/job_9a9b562d-e069-423e-aa59-16e2a60f5f68/artifacts/vvn4ocqm_o.jpg",
    "https://customer-assets.emergentagent.com/job_9a9b562d-e069-423e-aa59-16e2a60f5f68/artifacts/a2bre7aw_o.jpg",
  ],
};
